import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEllipse8 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={5} height={5} fill='none' {...props}>
    <circle cx={2.801} cy={2.5} r={2} fill='#323E54' />
  </svg>
);
export default SvgEllipse8;
